import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * useTaxProfile — reads the tenant's `tax_profile` (country, region, preset_id,
 * registration numbers…) off GET /tenant/tax-config, once per mount.
 *
 * Consumers that only need `country` (TaxCategoryField's SAC-code gate) do not need
 * the tax lines or tax_inclusive flag, so this hook exposes just the sub-object the
 * B75 offering editors actually bind to.
 *
 * Returns:
 *   - undefined  while the request is in flight (absence-tolerant callers should
 *     treat this the same as null — i.e. render today's UI)
 *   - null       request failed, or the tenant has no tax_profile configured yet
 *   - object     the tax_profile payload as sent by the backend
 */
export default function useTaxProfile() {
  const [profile, setProfile] = useState(undefined);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/tenant/tax-config");
        if (!cancelled) setProfile(data?.tax_profile || null);
      } catch (e) {
        if (!cancelled) setProfile(null);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return profile;
}
